<template>
  <div class="rss-notifications">
    <b-overlay :show="isRssFeedsLoading" opacity="1.0">
      <div>
        <template v-if="!numRssUpdates">
          <div class="d-flex justify-content-between">
            <h5 class="text-secondary px-1 my-3">
              There have been no updates the past {{ numDaysText }}.
            </h5>
            <div class="d-flex flex-column">
              <label
                style="align-self: center"
                class="text-nowrap pt-2 mb-0 mt-0 text-secondary"
              >
                Time Range
              </label>
              <b-form-radio-group
                class="align-self-end mt-0 mb-2 mx-2"
                v-model="selectedDate"
                :options="dateOptions"
                button-variant="outline-secondary"
                buttons
                size="sm"
              ></b-form-radio-group>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="mh-100" style="width: 1030px">
            <b-form-group>
              <b-form-input
                v-model="titleFilter"
                size="lg"
                placeholder="Search by title..."
                type="text"
                debounce="100"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="d-flex justify-content-between">
            <h6
              style="align-self: center"
              class="text-secondary p-- pb-0 mb-0 text-nowrap text-left"
            >
              Showing {{ filteredItems.length }} results.
            </h6>
            <div class="d-flex flex-column">
              <label
                style="align-self: center"
                class="text-nowrap pt-2 mb-0 mt-0 text-secondary"
              >
                Time Range
              </label>
              <b-form-radio-group
                class="align-self-end mt-0 mb-2 mx-2"
                v-model="selectedDate"
                :options="dateOptions"
                button-variant="outline-secondary"
                buttons
                size="sm"
              ></b-form-radio-group>
            </div>
          </div>

          <!-- hack to show loading spinner on loading -->
          <div v-show="!isRssFeedsLoading">
            <RssNotificationsList
              :fields="fields"
              :filteredItems="filteredItems"
            />
          </div>
        </template>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { DAY_MS } from '@/constants/constants';
import { getAWSDateTime } from '@/utils/dateUtils';
import RssNotificationsList from '@/components/RssNotificationsList.vue';

const ONE_DAYS_AGO_MS = Date.now() - DAY_MS * 1;
const ONE_WEEK_AGO_MS = Date.now() - DAY_MS * 7;
const ONE_MONTH_AGO_MS = Date.now() - DAY_MS * 31;

export default {
  name: 'RssNotificationsSection',
  components: {
    RssNotificationsList,
  },
  data() {
    return {
      titleFilter: '',
      selectedDate: ONE_DAYS_AGO_MS,
    };
  },
  computed: {
    ...mapGetters(['numRssUpdates', 'rssFeeds', 'isRssFeedsLoading']),

    numDaysText() {
      const numDaysAgo = Math.floor((Date.now() - this.selectedDate) / DAY_MS);
      if (numDaysAgo > 7) {
        return 'month';
      } else if (numDaysAgo > 2) {
        return 'week';
      } else {
        return 'two days';
      }
    },

    filteredItems() {
      return this.items.filter(({ title }) =>
        title.toLowerCase().includes(this.titleFilter.toLowerCase())
      );
    },

    items() {
      return this.rssFeeds.map(
        ({ feed_title, title, summary, url, date_published }) => ({
          feedTitle: feed_title,
          title,
          summary: summary.replace(/<[^>]*>?/gm, ''), //hack until the backend stop sending over html -->
          url,
          datePublished: new Date(
            date_published.replace('UTC', 'Z')
          ).toLocaleString(),
        })
      );
    },
  },

  watch: {
    selectedDate() {
      this.getRssFeedsAsync();
    },
  },
  created() {
    this.DAY_MS = DAY_MS;
    this.dateOptions = [
      { text: 'Day', value: ONE_DAYS_AGO_MS },
      { text: 'Week', value: ONE_WEEK_AGO_MS },
      { text: 'Month', value: ONE_MONTH_AGO_MS },
    ];
    this.fields = [
      { key: 'feedTitle', label: 'Feed', sortable: true },
      { key: 'title', sortable: true },
      { key: 'summary', sortable: true },
      { key: 'datePublished', sortable: true },
    ];
  },
  mounted() {
    this.getRssFeedsAsync();
  },

  methods: {
    ...mapActions(['fetchRssFeeds']),
    getRssFeedsAsync() {
      return this.fetchRssFeeds({
        dateTimeSince: getAWSDateTime(false, this.selectedDate).split('Z')[0],
      });
    },
  },
};
</script>

<style scoped>
.rss-notifications {
  display: flex;
  flex-direction: column;
}
</style>
